/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-unused-vars */
import React, { useState, useContext } from 'react';
import ContentLayout from 'components/Common/ContentLayout';
import TeamsAPI from 'api/TeamsAPI';
import GroupAPI from 'api/GroupAPI';
import PaymentsAPI from 'api/PaymentsAPI';
import { Redirect } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { GlobalContext } from 'providers/GlobalProvider';
import { Button } from '@mui/material';
import UsersAPI from 'api/UsersAPI';

const ManualTeamSetup: React.FC = () => {
  const [ formValues, setFormValues ] = useState({
    teamName: '',
    teamAdmin: ''
  });
  const { cur_user } = useContext(GlobalContext);
  const { enqueueSnackbar } = useSnackbar();
  const watchlistRoleId = process.env.REACT_APP_WATCHLIST_ID!;
  const cyberProtectionRoleId = process.env.REACT_APP_CYBER_PROTECTION_ID!;
  const biteListRoleId = process.env.REACT_APP_BITE_LIST_ID!;
  const tradeProtRoleId = process.env.REACT_APP_TRADE_PROTECTION_ID!;
  const biteScoreRoleId = process.env.REACT_APP_BITE_SCORE_ID!;
  const biteVizRoleId = process.env.REACT_APP_BITE_VIZ_ID!;

  if (cur_user.bite_super_admin === false) {
    return <Redirect to='/' />;
  }

  const handleSubmit = async(formVals: any) => {
    const new_team: any = {
      name: formVals.teamName,
      team_admin_id: formVals.teamAdmin,
      team_id: '',
      keycloakUserId: cur_user?.basics?.id
    };
    if (formVals.teamName === '') {
      enqueueSnackbar('Team name must not be blank');
      return;
    }
    const teamResp = await TeamsAPI.createTeam({ newTeam: new_team });
    const userResp = await UsersAPI.searchUsers(new_team.team_admin_id);
    if(teamResp?.success && userResp?.success){
      const teamId = teamResp.result.id;
      new_team.team_id = teamId;
      const adminId = userResp?.result[0].id;
      const addUser = await GroupAPI.assignGroupToUser(teamId, adminId);
      if (addUser?.success) {
        const createStripeCustomer = await PaymentsAPI.createCustomer(new_team);
        if (createStripeCustomer?.success) {
          const addWatchlistRole = await GroupAPI.addRoleToGroup(teamId, watchlistRoleId, 'watchlist-data');
          if (addWatchlistRole?.success) {
            const addCyberRole = await GroupAPI.addRoleToGroup(teamId, cyberProtectionRoleId, 'cyber-protection');
            if (addCyberRole?.success) {
              const addBiteListRole = await GroupAPI.addRoleToGroup(teamId, biteListRoleId, 'bite-list');
              if (addBiteListRole?.success) {
                const addTradeProtRole = await GroupAPI.addRoleToGroup(teamId, tradeProtRoleId, 'trade-protection');
                if (addTradeProtRole?.success) {
                  const addBiteScoreRole = await GroupAPI.addRoleToGroup(teamId, biteScoreRoleId, 'bite-score');
                  if (addBiteScoreRole?.success) {
                    const addBiteVizRole = await GroupAPI.addRoleToGroup(teamId, biteVizRoleId, 'customizable');
                    if (addBiteVizRole?.success) {
                      enqueueSnackbar('New team created', { variant: 'info' });
                      history.go(0);
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else if(teamResp || userResp){
      const error_msg = 'Error creating new team. Team name may already be in use';
      enqueueSnackbar(error_msg, { variant: 'error' });
    }
  };

  return (
    <ContentLayout title='Manual Setup for External BITE Teams'>
      <div className='score-form-entity'>
        <div className='score-form-row'>
          <div className='score-form-combo'>
            <p className='score-form-label'>Team Name</p>
            <input
              onChange={(e) => setFormValues({
                ...formValues,
                teamName: e.target.value,
              })}
              className='score-form-input'
              name='teamName'
              value={formValues.teamName}
            />
          </div>
          <div className='score-form-combo'>
            <p className='score-form-label'>Team Admin</p>
            <input
              onChange={(e) => setFormValues({
                ...formValues,
                teamAdmin: e.target.value,
              })}
              className='score-form-input'
              name='teamAdmin'
              value={formValues.teamAdmin}
            />
          </div>
        </div>
        <Button
          type='submit'
          className='wl-search-btn'
          onClick={() => handleSubmit(formValues)}
        >
          Submit
        </Button>
      </div>
    </ContentLayout>
  );
};

export default ManualTeamSetup;
